var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { DynamicComponent } from "../dynamic-component";
const defaultProps = {
    size: { xsmall: ["1rem", "1.5rem"] },
    fontWeight: 400,
    isUppercase: false,
};
export const MainStyle = styled((_a) => {
    var { tag = "div" } = _a, props = __rest(_a, ["tag"]);
    return (_jsx(DynamicComponent, Object.assign({}, props, { tag: tag })));
}) `
  &&& {
    font-family: ${({ theme }) => theme.fontTokens.defaultFont};
    font-size: ${({ size = defaultProps.size }) => { var _a, _b; return (_b = (_a = size === null || size === void 0 ? void 0 : size.xsmall) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : "1rem"; }};
    font-weight: ${({ fontWeight = defaultProps.fontWeight }) => fontWeight};
    line-height: ${({ size = defaultProps.size }) => { var _a, _b; return (_b = (_a = size === null || size === void 0 ? void 0 : size.xsmall) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : "1.5rem"; }};
    text-transform: ${({ isUppercase = defaultProps.isUppercase }) => isUppercase ? "uppercase" : "inherit"};

    @media ${({ theme }) => theme.device.medium} {
      ${({ size }) => (size === null || size === void 0 ? void 0 : size.medium)
    ? `font-size: ${size.medium[0]}; line-height: ${size.medium[1]}`
    : ""}
    }

    @media ${({ theme }) => theme.device.large} {
      ${({ size }) => (size === null || size === void 0 ? void 0 : size.large)
    ? `font-size: ${size.large[0]}; line-height: ${size.large[1]}`
    : ""}
    }

    @media ${({ theme }) => theme.device.xlarge} {
      ${({ size }) => (size === null || size === void 0 ? void 0 : size.xlarge)
    ? `font-size: ${size.xlarge[0]}; line-height: ${size.xlarge[1]}`
    : ""}
    }
  }
`;
